import { render, staticRenderFns } from "./SmartSmsLanding.vue?vue&type=template&id=b1ac20b6"
import script from "./SmartSmsLanding.vue?vue&type=script&lang=js"
export * from "./SmartSmsLanding.vue?vue&type=script&lang=js"
import style0 from "./SmartSmsLanding.vue?vue&type=style&index=0&id=b1ac20b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports